import React, { useState, useEffect, useCallback } from "react";
import { Link, animateScroll as scroll } from "react-scroll";
import { AppBar, Toolbar, Typography, makeStyles, Button } from "@material-ui/core";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import '../../../styles/navbar.scss';
import Modalpopup from '../Modalpopups/Modalpopup';
import ModalpopupCalqulator from '../Modalpopups/ModalpopupCalqulator';
import { Link as Li } from 'react-router-dom';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import { MenuItem } from '@material-ui/core';
import MenuList from '@material-ui/core/MenuList';
import { useHistory } from 'react-router-dom';
import NestedMenuItem from 'material-ui-nested-menu-item';
import MenuIcon from '@material-ui/icons/Menu';
import { useGAEventsTracker } from "../../../util/gtag";
import config from "../../config/config";
import { Helmet } from "react-helmet";

const useStyles = makeStyles(() => ({
    title: {
        flexGrow: 1,
    },
    header: {
        position: 'sticky',
        backgroundColor: '#fff',
        color: "black",
        "@media (max-width: 900px)": {
            paddingLeft: 0,
        },
    },
    logo: {
        fontFamily: "Work Sans, sans-serif",
        fontWeight: 600,
        color: "black",
        textAlign: "left",
        width: '100%',
    },
    menuButton: {
        fontWeight: 700,
        size: "18px",
        marginLeft: "38px",
    },
    toolbar: {
        display: "flex",
        justifyContent: "space-between",
    },
    drawerContainer: {
        padding: "20px 30px",

    },
}));

export default function NavbarDefault(props) {
    const GAEventTrackerHome = useGAEventsTracker("/");
    const GAEventTrackerLender = useGAEventsTracker("/lender-partner")
    const GAEventTrackerAgents = useGAEventsTracker("/agent-partner")
    const GAEventTrackerContact = useGAEventsTracker("/contact us");
    const GAEventTrackerAboutUs = useGAEventsTracker("/aboutus");
    const GAEventTrackerFaq = useGAEventsTracker("/faq")
    const GAEventTrackerResources = useGAEventsTracker("/resources")

    const history = useHistory();
    const [openSubmit, setOpenSubmit] = useState(false);
    const [openCalculatorSubmit, setOpenCalculatorSubmit] = useState(false)
    const [headingBorderAbout, setHeadingBorderAbout] = useState(false)
    const [headingBorderFaq, setHeadingBorderFaq] = useState(false)
    const [headingBorderLender, setHeadingBorderLender] = useState(false)
    const [headingBorderRealtor, setHeadingBorderRealtor] = useState(false)
    const [homeBorder, setHomeBorder] = useState(false)
    const [drawerstate, setDrawerState] = useState(false)

    const handleClickOpen2 = () => {
        setOpenSubmit(!openSubmit);
    };
    const handleClickOpenCalculator = () => {
        setOpenCalculatorSubmit(!openCalculatorSubmit)
    }
    const { header, logo, toolbar, drawerContainer } = useStyles();
    const [state, setState] = useState({
        mobileView: false,
        drawerOpen: false,
    });
    const { mobileView } = state;

    const [open, setOpen] = React.useState(false);
    const [openRes, setOpenRes] = useState(false);
    const [openPDF, setOpenPDF] = useState(false)
    const anchorRef = React.useRef(null);
    const anchorRefRes = React.useRef(null);
    const anchorRefPDF = useState(null);

    const [menuPosition, setMenuPosition] = useState(null)

    const handleToggle = () => {
        setOpen(true);
    };
    const handleToggleOut = () => {
        setOpen(false);
    }
    const handleToggleRes = () => {
        setOpenRes((prevOpenRes) => true);
    };
    const handleToggleOutRes = () => {
        setOpenPDF(false)
        setOpenRes(false);
    }
    const handleTogglePDF = () => {
        setOpenPDF(true)
    }
    const handleTogglePDFOut = () => {
        setOpenPDF(false)
    }
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {

            return
        }

        if (menuPosition) {
            return;
        }

        event.preventDefault();
        setMenuPosition({
            top: event.pageY,
            left: event.pageX
        })

        setOpen(false);
    };

    const handleCloseRes = (event) => {
        if (anchorRefRes.current && anchorRefRes.current.contains(event.target)) {

            return
        }

        if (menuPosition) {
            return;
        }

        event.preventDefault();
        setMenuPosition({
            top: event.pageY,
            left: event.pageX
        })

        setOpenRes(false);
    };

    const handleClosePDF = (event) => {
        if (anchorRefPDF.current && anchorRefPDF.current.contains(event.target)) {

            return
        }

        if (menuPosition) {
            return;
        }

        event.preventDefault();
        setMenuPosition({
            top: event.pageY,
            left: event.pageX
        })

        setOpenPDF(false);
    };

    const handleHome = () => {
        setTimeout(() => {
            setDrawerState(!drawerstate)
        }, 100)
    }

    const handleFaq = () => {
        props.setFaqRealEstateAgentOpen("false")
        setTimeout(() => {
            setDrawerState(!drawerstate)
        }, 100)
    }

    const handleFaqDesktop = () => {
        props.setFaqRealEstateAgentOpen("false")
    }

    const handleLeaderShipTeam = () => {
        localStorage.setItem('aboutus_route', "leadershipteam")
        history.push('/aboutus')
        const yOffset = -100;
        setTimeout(() => {
            const element = document.getElementById('leadershipteam')
            if (element) {
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        }, 100);
        setOpen(false);
    }

    const handleLeaderShipTeamMob = () => {
        localStorage.setItem('aboutus_route', "leadershipteam")
        history.push('/aboutus')
        const yOffset = 700;
        setTimeout(() => {
            setOpen(false);
            const element = document.getElementById('leadershipteam')
            if (element) {
                const y = element.getBoundingClientRect().top + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
            setDrawerState(false);
        }, 100);
    }

    const handlePressRelease = () => {
        localStorage.setItem('aboutus_route', "pressreleases")
        history.push('/aboutus')
        const yOffset = -50;
        setTimeout(() => {
            const element = document.getElementById('pressreleases')
            if (element) {
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        }, 600);
        setOpen(false);
    }

    const handlePressReleaseMob = () => {
        history.push('/aboutus')
        localStorage.setItem('aboutus_route', "pressreleases")
        const yOffset = -50;
        setTimeout(() => {
            setOpen(false);
            const element = document.getElementById('pressreleases')
            if (element) {
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
            setDrawerState(false);
        }, 1200);
        setOpen(false);
    }

    const handleMobileMenu = (event, state) => {
        event.stopPropagation();
        setDrawerState(state);
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
    };

    const menuClicked = (e) => {
        e.stopPropagation()
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    function handleListKeyDownRes(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    function handleListKeyDownPDF(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenPDF(false);
        }
    }
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    const prevOpenRes = React.useRef(openRes);
    React.useEffect(() => {
        if (prevOpenRes.current === true && openRes === false) {
            anchorRefRes.current.focus();
        }
        prevOpenRes.current = openRes;
    }, [openRes]);

    const prevOpenPDF = React.useRef(openPDF);
    React.useEffect(() => {
        if (prevOpenPDF.current === true && openPDF === false) {
            anchorRefPDF.current.focus();
        }
        prevOpenPDF.current = openPDF;
    }, [openPDF]);

    const handlePressApi = () => {
        fetch(`${config.baseUrlCP}get-news/`, {
            headers: {
                "Authorization": `${process.env.REACT_APP_API_KEY}`,
                'Accept-Encoding': 'gzip, deflate',
            }
        })
            .then(async response => {
                const results = await response.json();
                if (response.status === 200 || response.status === 201) {
                    props.setPressReleaseResponse(results)
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }

    function Contactus() {
        return (
            <>
                <div className="container-fluid m-0 top-padding-small bottom-padding-small px-md-5">
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5">
                            <div className="justify-content-md-between align-items-md-center">
                                <h3 className="headerfont">Contact Us</h3>
                                <div className="contentfonthead">To speak with a Calque representative, call</div>
                                <div className="contentfont">
                                    <a className="tel" href={`tel:${props?.contactGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.contactGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className="contentfonthead">Or send an email to</div>
                                <div className="contentfont">
                                    <a className="mailto" href={`mailto:${props?.emailGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.emailGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className="contentfonthead">Our address is</div>
                                <div className="contentfont">
                                    <b>
                                        <p className="contactAddress">
                                            {props?.addressGlobal?.application_config_value}
                                        </p>
                                    </b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    // function CalculatorWidget() {
    //     return (
    //         <>
    //             <div className="calculator-widget">
    //             </div>
    //             <Helmet>
    //                 <script src={`${process.env.REACT_APP_CALQULATOR}index.js`}></script>
    //             </Helmet>
    //         </>
    //     )
    // }

    useEffect(() => {
        const setResponsiveness = () => {
            return window.innerWidth < 770
                ? setState((prevState) => ({ ...prevState, mobileView: true }))
                : setState((prevState) => ({ ...prevState, mobileView: false }));
        };
        setResponsiveness();
        window.addEventListener("resize", () => setResponsiveness());
    }, []);

    useEffect(() => {
        if (window.location.pathname === "/aboutus") {
            setHeadingBorderAbout(true)
        } else if (window.location.pathname === "/faq") {
            setHeadingBorderFaq(true)
        } else if (window.location.pathname === "/") {
            setHomeBorder(true)
        } else if (window.location.pathname === "/lending-partner") {
            setHeadingBorderLender(true)
        } else if (window.location.pathname === "/agent-partner") {
            setHeadingBorderRealtor(true)
        }
    }, [])

    useEffect(() => {
        document.addEventListener('click', function (e) {
            setDrawerState(false)
        });
    })

    const mobileNav = () => {
        return (
            <>
                <Toolbar className={toolbar}>
                    <div className="col-12 jost-bold" >
                        <div className="row w-100 m-0">
                            <Typography variant="h6" component="h1" className={logo}>
                                <div className="d-flex">
                                    <div className="w-50">
                                        <Li to="/" onClick={(e) => { GAEventTrackerHome("Home", 1) }}>
                                            <img src="/assets/logos/calque_logo_blue_prototype_compressed.webp" alt="Logo" width="142px" height="35px"></img>
                                        </Li>
                                    </div>
                                    <div className="w-50">
                                        <div className="d-flex align-items-center justify-content-end" style={{ height: '35px' }}>
                                            <div onClick={(e) => handleMobileMenu(e, !drawerstate)} onKeyDown={(e) => handleMobileMenu(e, !drawerstate)} style={{ cursor: 'pointer' }}>
                                                <MenuIcon />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Typography>
                        </div>
                    </div>
                </Toolbar >
                {drawerstate == true ?
                    <div id="mobilemenu" style={{ position: 'absolute', width: '100%', backgroundColor: '#fff', top: '3.5rem', borderTop: '1px solid #eee' }} onClick={menuClicked}>
                        <div id="menuAccordian">
                            <Accordion className="p-2 pl-4">
                                <Li activeclass="active"
                                    to="/"
                                    href="/"
                                    spy="true"
                                    smooth="true"
                                    offset={-70}
                                    onClick={(e) => { GAEventTrackerHome("Home", 1); handleHome() }}
                                    duration={500}>
                                    Home
                                </Li>
                            </Accordion>

                            <Accordion className="p-2 pl-4">
                                <Li activeclass="active"
                                    to="lending-partner"
                                    spy="true"
                                    smooth="true"
                                    offset={-70}
                                    onClick={(e) => { GAEventTrackerLender("Header", 1); handleHome() }}
                                    duration={500}>
                                    Lenders
                                </Li>
                            </Accordion>

                            <Accordion className="p-2 pl-4">
                                <Li activeclass="active"
                                    to="agent-partner"
                                    spy="true"
                                    smooth="true"
                                    offset={-70}
                                    onClick={(e) => { GAEventTrackerAgents("Header", 1); handleHome() }}
                                    duration={500}>
                                    Agents
                                </Li>
                            </Accordion>

                            <Accordion id="aboutmenu">
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>
                                        <Li
                                            to="#"
                                            activeclass="active"
                                            spy="true"
                                            smooth="true"
                                            offset={-70}
                                            className="ml-2 font-weight-normal montserrat-medium"
                                            duration={500}
                                            onClick={(e) => { GAEventTrackerAboutUs("Header", 1) }}
                                        >
                                            About Us
                                        </Li>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className="w-100" style={{ backgroundColor: '#eee' }}>
                                        <div className="pl-5 pt-2 pb-2">
                                            <Li
                                                to="#"
                                                className="font-weight-normal"
                                                onClick={(e) => { GAEventTrackerAboutUs("Leadership Team"); handleLeaderShipTeamMob(e); handlePressApi() }}
                                            >
                                                Leadership Team
                                            </Li>
                                        </div>

                                        <div className="pl-5 pt-2 pb-2">
                                            <Li
                                                to="#"
                                                className="font-weight-normal"
                                                onClick={(e) => { GAEventTrackerAboutUs("News"); handlePressReleaseMob(); handlePressApi() }}
                                            >
                                                News
                                            </Li>
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion id="resourcemenu">
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>
                                        <Li
                                            to="#"
                                            activeclass="active"
                                            spy="true"
                                            smooth="true"
                                            offset={-70}
                                            className="ml-2 font-weight-normal montserrat-medium"
                                            duration={500}
                                            onClick={(e) => { GAEventTrackerResources("Header", 1) }}
                                        >
                                            Resources
                                        </Li>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails className="p-0">
                                    <div className="w-100" style={{ backgroundColor: '#eee' }}>
                                        <div className="pl-5 pt-2 pb-2">
                                            <a href="/calculator" className="font-weight-normal" onClick={(e) => { GAEventTrackerResources("Calculator"); }}>
                                                Calculator
                                            </a>
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion className="p-2 pl-4">
                                <Li activeclass="active"
                                    to="faq"
                                    spy="true"
                                    smooth="true"
                                    className="faqs"
                                    offset={-70}
                                    onClick={(e) => { GAEventTrackerFaq("Header", 1); handleFaq() }}
                                    duration={500}>
                                    FAQs
                                </Li>
                            </Accordion>
                            <Accordion className="p-2 pl-4">
                                <Link
                                    activeclass="active"
                                    className="text-primary"
                                    to="contact"
                                    spy="true"
                                    smooth="true"
                                    offset={-70}
                                    duration={500}
                                    onClick={(e) => { GAEventTrackerContact("Header", 1); handleClickOpen2() }}>
                                    Contact
                                </Link>
                            </Accordion>

                        </div>
                    </div>
                    : ''
                }
            </>
        )
    };

    const desktopNav = () => {
        return (
            <Toolbar className={toolbar}>
                <div className="col-6 col-lg-6 col-md-4 jost-bold" >
                    <Typography variant="h6" component="h1" className={logo}>
                        <div className="login_img d-flex align-items-center justify-content-start">
                            <Li to="/" onClick={(e) => { GAEventTrackerHome("Home", 1) }}>
                                <img src="/assets/logos/calque_logo_blue_prototype_compressed.webp" alt="Logo" width="142px" height="35px"></img>
                            </Li>
                        </div>
                    </Typography>
                </div>

                <div className="col-6 col-lg-6 col-md-8 d-flex justify-content-end align-items-center jost-bold" >
                    <div className="w-100 d-flex justify-content-between align-items-center global-nav">
                        <Li activeclass="active"
                            to="lending-partner"
                            spy="true"
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { GAEventTrackerLender("Header", 1) }}
                            className={headingBorderLender === true ? "faqborder faqs" : "aboutus faqs"}
                            duration={500}>
                            Lenders
                        </Li>
                        <Li activeclass="active"
                            to="agent-partner"
                            spy="true"
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { GAEventTrackerAgents("Header", 1) }}
                            className={headingBorderRealtor === true ? "faqborder faqs" : "aboutus faqs"}
                            duration={500}>
                            Agents
                        </Li>
                        <div onMouseLeave={handleToggleOut}>
                            <Li
                                to="#"
                                activeclass="active"
                                className="NavHeader aboutus"
                                spy="true"
                                smooth="true"
                                offset={-70}
                                onMouseOver={handleToggle}
                                aria-controls={open ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                ref={anchorRef}
                                onClick={(e) => { GAEventTrackerAboutUs("Header", 1) }}
                                disableripple="true"
                                disableelevation="true"
                                disablefocusripple="true"
                                duration={500}>
                                About Us
                            </Li>
                            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal onMouseLeave={handleToggleOut}>
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                    >
                                        <Paper>
                                            <ClickAwayListener onClickAway={handleClose}>
                                                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                                    <MenuItem onClick={(e) => { GAEventTrackerAboutUs("leadership team"); handleLeaderShipTeam(e); handlePressApi() }}>Leadership Team</MenuItem>
                                                    <MenuItem onClick={(e) => { GAEventTrackerAboutUs("News"); handlePressRelease(); handlePressApi() }}>News</MenuItem>
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </div>
                        <div onMouseLeave={handleToggleOutRes}>
                            <Li to="#"
                                activeclass="active"
                                className="NavHeader aboutus"
                                spy="true"
                                smooth="true"
                                offset={-70}
                                onMouseOver={handleToggleRes}
                                aria-controls={openRes ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                ref={anchorRefRes}
                                onClick={(e) => { GAEventTrackerResources("Header", 1) }}
                                disableripple="true"
                                disableelevation="true"
                                disablefocusripple="true"
                                duration={500}>
                                Resources
                            </Li>
                            <Popper open={openRes} anchorEl={anchorRefRes.current} role={undefined} transition disablePortal onMouseLeave={handleToggleOutRes}>
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                    >
                                        <Paper>
                                            <ClickAwayListener onClickAway={handleCloseRes}>
                                                <MenuList autoFocusItem={openRes} id="menu-list-grow" onKeyDown={handleListKeyDownRes}>
                                                    <a href="/calculator" style={{ color: 'black' }}><MenuItem onClick={(e) => { GAEventTrackerResources("Calculator"); }}>Calculator</MenuItem></a>
                                               </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </div>

                        <Li activeclass="active"
                            to="faq"
                            spy="true"
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { GAEventTrackerFaq("Header", 1); handleFaqDesktop() }}
                            className={headingBorderFaq === true ? "faqborder faqs" : "aboutus faqs"}
                            duration={500}>
                            FAQs
                        </Li>

                        <Button
                            variant="contained"
                            disableelevation="true"
                            onClick={(e) => { GAEventTrackerContact("Contact Us", 1); handleClickOpen2() }}
                            style={{ color: 'white', backgroundColor: '#2A83C2' }}
                        >
                            Contact
                        </Button>
                    </div>
                </div>

            </Toolbar>
        )
    }

    return (
        <AppBar className={header}>
            {mobileView ? mobileNav() : desktopNav()}
            <Modalpopup open={openSubmit} handleClickOpen={handleClickOpen2} contact={Contactus()} />
            {/* <ModalpopupCalculator open={openCalculatorSubmit} handleClickOpen={handleClickOpenCalculator} contact={CalculatorWidget()} /> */}
        </AppBar>
    );
}